import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import HOC from '../../components/HOC/HOC';
import { SuccessfullyModal } from '../../components/Modals/Modals';
import addjob from '../../css/style.module.css';
import { getApi, postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import img2 from '../../assest/loading1.gif';
import { formatDateTime, getOrderFormattedTime } from '../../utils/utils';

const AssignJob = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [data, setData] = useState({});
  const [partnerlist, setPatnerList] = useState([]);

  const [jobsdata, setJobsData] = useState([]);
  const [loadingjob, setLoadingJob] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get('page')) || 1;

  const [formData, setFormData] = useState({
    subcategoryId: [],
    staffId: [],
  });

  const fetchData = useCallback(async () => {
    await getApi(endPoints.getorderbyid(id), {
      setResponse: response => {
        setData(response?.data);
      },
      setLoading,
      errorMsg: 'Failed to fetch data!',
    });
  }, [id]);

  const fetchSubcategoryData = async () => {
    await getApi(endPoints.getallsubcategory, {
      setResponse: setJobsData,
      setLoading: setLoadingJob,
      errorMsg: 'Failed to fetch jobs!',
    });
  };

  const fetchFilteredPartners = async subcategoryIds => {
    await getApi(endPoints.getallstaffbysubcategory(subcategoryIds), {
      setResponse: setPatnerList,
      setLoading: setLoading1,
      errorMsg: 'Failed to fetch partner!',
    });
  };

  useEffect(() => {
    if (formData.subcategoryId.length) {
      fetchFilteredPartners(formData.subcategoryId);
    } else {
      setPatnerList([]);
    }
  }, [formData.subcategoryId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    fetchSubcategoryData();
  }, []);

  const handleAssign = async () => {
    if (formData.staffId.length === 0) {
      alert('Please select at least one staff member.');
      return;
    }
    const payload = {
      staffId: formData.staffId,
    };
    await postApi(endPoints.assignpartnerbyorderid(id), payload, {
      setLoading,
      errorMsg: 'Failed to assign the order!',
    });
    setShow(true);
    setTimeout(() => {
      setShow(false);
      navigate('/orders?page=' + page);
    }, 2000);
  };

  const MultiSelectCheckbox = ({
    options,
    selectedValues,
    onSelect,
    onRemove,
    placeholder,
    valueField = '_id',
    labelField = 'name',
    disabled = false,
    searchable = false,
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [tempSelections, setTempSelections] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const wrapperRef = useRef(null);

    useEffect(() => {
      if (isOpen) {
        setTempSelections(selectedValues || []);
      }
    }, [isOpen, selectedValues]);

    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const filteredOptions = searchable
      ? options?.filter(option =>
          (option[labelField] || '').toLowerCase().includes(searchTerm.toLowerCase())
        )
      : options;

    const handleTempSelect = value => {
      setTempSelections(prev =>
        prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
      );
    };

    const applySelections = () => {
      const toAdd = tempSelections.filter(v => !(selectedValues || []).includes(v));
      const toRemove = (selectedValues || []).filter(v => !tempSelections.includes(v));

      toAdd.forEach(value => onSelect(value));
      toRemove.forEach(value => onRemove(value));

      setIsOpen(false);
    };

    const cancelSelections = () => {
      setTempSelections(selectedValues || []);
      setIsOpen(false);
    };

    const toggleSelectAll = () => {
      if (tempSelections.length === filteredOptions.length) {
        setTempSelections([]);
      } else {
        setTempSelections(filteredOptions.map(opt => opt[valueField]));
      }
    };

    return (
      <div className={addjob.multiSelectWrapper} ref={wrapperRef}>
        <div
          className={`${addjob.selectInput} ${disabled ? addjob.disabled : ''}`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
        >
          {placeholder}
          <span className={addjob.arrowIcon}>
            {isOpen ? <IoIosArrowUp size={20} /> : <IoIosArrowDown size={20} />}
          </span>
          {disabled && <span className={addjob.disabledText}>(Select subcategories first)</span>}
        </div>

        {isOpen && (
          <div className={addjob.dropdown}>
            {searchable && (
              <div className={addjob.searchBox}>
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                  disabled={disabled}
                />
              </div>
            )}

            <div className={addjob.selectAllContainer}>
              <button
                type="button"
                onClick={toggleSelectAll}
                className={addjob.selectAllButton}
                disabled={disabled}
              >
                {tempSelections.length === filteredOptions?.length ? 'Deselect All' : 'Select All'}
              </button>
            </div>

            <div className={addjob.optionsContainer}>
              {filteredOptions?.length > 0 ? (
                filteredOptions.map(option => (
                  <h5 key={option[valueField]} className={addjob.optionItem}>
                    <input
                      type="checkbox"
                      checked={tempSelections.includes(option[valueField])}
                      onChange={() => handleTempSelect(option[valueField])}
                      disabled={disabled}
                    />
                    {option[labelField]}
                    {labelField === 'firstName' &&
                      option.lastName &&
                      ` ${option.lastName} (Staff ID:${option.Id})`}
                  </h5>
                ))
              ) : (
                <div className={addjob.noOptions}>No options available</div>
              )}
            </div>

            <div className={addjob.dropdownFooter}>
              <button
                type="button"
                className={addjob.cancelButton}
                onClick={cancelSelections}
                disabled={disabled}
              >
                Cancel
              </button>
              <button
                type="button"
                className={addjob.applyButton}
                onClick={applySelections}
                disabled={disabled}
              >
                Apply ({tempSelections.length})
              </button>
            </div>
          </div>
        )}

        <div className={addjob.selectedTags}>
          {selectedValues?.map(value => {
            const option = options.find(opt => opt[valueField] === value);
            return (
              <div key={value} className={addjob.tag}>
                <span>
                  {option?.[labelField]}
                  {labelField === 'firstName' && option?.lastName && ` ${option.lastName}`}
                </span>
                <button
                  type="button"
                  className={addjob.removeBtn}
                  onClick={() => onRemove(value)}
                  disabled={disabled}
                >
                  ×
                </button>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (!data?.jobs) return;

    const allSubCategories = data.jobs
      .flatMap(job => job.subCategories || [])
      .map(sc => sc.subCategoryId._id)
      .filter(Boolean);

    setFormData(prev => ({
      ...prev,
      subcategoryId: allSubCategories.length > 0 ? allSubCategories : [],
    }));
  }, [data?.jobs]);

  useEffect(() => {
    if (formData.subcategoryId.length > 0) {
      fetchFilteredPartners(formData.subcategoryId);
    } else {
      setPatnerList([]);
    }
  }, [formData.subcategoryId]);

  return (
    <>
      <SuccessfullyModal
        show={show}
        handleClose={() => setShow(false)}
        text={'Successfully Assigned'}
      />
      <div className={addjob.jobmanagementCotainer}>
        <div className={addjob.jobtoppart}>
          <div className={addjob.pagetitle}>
            <h6>Assign Job </h6>
          </div>
        </div>
        {loading ? (
          <div className={addjob.loadingnormal}>
            <img src={img2} alt="Loading" width={100} height={100} />
          </div>
        ) : (
          <div className={addjob.addjobcontainer}>
            <div className={addjob.addusercontainer}>
              <div className={addjob.adduserleftcontainer}>
                <h6>Owner Details</h6>
                <div className={addjob.adduserleftdetails}>
                  <div className={addjob.adduserleftprofileimage}>
                    <img src={data?.user?.image} alt="" />
                  </div>
                  <div className={addjob.adduserleftuserdetails}>
                    <div className={addjob.adduserleftuser}>
                      <p>Name</p>
                      <span>:</span>
                      <p>
                        {data?.user?.firstName} {data?.user?.lastName}
                      </p>
                    </div>
                    <div className={addjob.adduserleftuser}>
                      <p>Email</p>
                      <span>:</span>
                      <p>{data?.user?.email}</p>
                    </div>
                    <div className={addjob.adduserleftuser}>
                      <p>Number</p>
                      <span>:</span>
                      <p>+91{data?.user?.phone}</p>
                    </div>
                  </div>
                  <div className={addjob.userprofileadress}>
                    <h6>Job Details</h6>
                    <div className={addjob.adduserleftuserdetails}>
                      <div className={addjob.adduserleftuser}>
                        <p>OrderId</p>
                        <span>:</span>
                        <h5>{data?.orderId}</h5>
                      </div>
                      <div className={addjob.adduserleftuser}>
                        <p>Category</p>
                        <span>:</span>
                        <ul>
                          {data?.jobs?.length === 0 ? (
                            <p>N/A</p>
                          ) : (
                            data?.jobs?.map((itme, rowIndex) => (
                              <li key={rowIndex}>{itme?.category?.name}</li>
                            ))
                          )}
                        </ul>
                      </div>
                      <div className={addjob.adduserleftuser}>
                        <p>SubCategory</p>
                        <span>:</span>
                        <ul>
                          {data?.jobs?.length === 0 ? (
                            <p>N/A</p>
                          ) : (
                            data?.jobs?.flatMap(job =>
                              job?.subCategories?.length === 0
                                ? [<li key={`empty-${job._id}`}>N/A</li>]
                                : job?.subCategories?.map((item, rowIndex) => (
                                    <li key={`${job._id}-${rowIndex}`}>
                                      {item?.subCategoryId?.name}
                                    </li>
                                  ))
                            )
                          )}
                        </ul>
                      </div>
                      <div className={addjob.adduserleftuser}>
                        <p>Date</p>
                        <span>:</span>
                        <ul>
                          {data?.jobs?.length === 0 ? (
                            <p>N/A</p>
                          ) : (
                            data?.jobs?.map((itme, rowIndex) => (
                              <li key={rowIndex}>{formatDateTime(itme?.date)}</li>
                            ))
                          )}
                        </ul>
                      </div>
                      <div className={addjob.adduserleftuser}>
                        <p>Start date</p>
                        <span>:</span>
                        <ul>
                          {data?.jobs?.length === 0 ? (
                            <p>N/A</p>
                          ) : (
                            data?.jobs?.flatMap(job =>
                              job?.subCategories?.length === 0
                                ? [<li key={`empty-${job._id}`}>N/A</li>]
                                : job?.subCategories?.map((item, rowIndex) => (
                                    <li key={`${job._id}-${rowIndex}`}>
                                      {getOrderFormattedTime(item?.fromTime)}
                                    </li>
                                  ))
                            )
                          )}
                        </ul>
                      </div>
                      <div className={addjob.adduserleftuser}>
                        <p>End date</p>
                        <span>:</span>
                        <ul>
                          {data?.jobs?.length === 0 ? (
                            <p>N/A</p>
                          ) : (
                            data?.jobs?.flatMap(job =>
                              job?.subCategories?.length === 0
                                ? [<li key={`empty-${job._id}`}>N/A</li>]
                                : job?.subCategories?.map((item, rowIndex) => (
                                    <li key={`${job._id}-${rowIndex}`}>
                                      {getOrderFormattedTime(item?.toTime)}
                                    </li>
                                  ))
                            )
                          )}
                        </ul>
                      </div>
                      <div className={addjob.adduserleftuser}>
                        <p>Total Time</p>
                        <span>:</span>
                        <ul>
                          {data?.jobs?.length === 0 ? (
                            <p>N/A</p>
                          ) : (
                            data?.jobs?.flatMap(job =>
                              job?.subCategories?.length === 0
                                ? [<li key={`empty-${job._id}`}>N/A</li>]
                                : job?.subCategories?.map((item, rowIndex) => (
                                    <li key={`${job._id}-${rowIndex}`}>{item?.totalTime}</li>
                                  ))
                            )
                          )}
                        </ul>
                      </div>
                      <div className={addjob.adduserleftuser}>
                        <p>Total Price</p>
                        <span>:</span>
                        <h5>₹{data?.total}</h5>
                      </div>
                      <div className={addjob.adduserleftuser}>
                        <p>Job Status</p>
                        <span>:</span>
                        <h5>{data?.jobStatus}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={addjob.adduserrightcontainer}>
                <h6>Assign Job</h6>
                <div className={addjob.assignjobselectcontainer}>
                  <div className={addjob.addjobselect}>
                    <label htmlFor="">Select Job*</label>
                    <MultiSelectCheckbox
                      options={jobsdata?.data || []}
                      selectedValues={formData.subcategoryId || []}
                      onSelect={value =>
                        setFormData(prev => ({
                          ...prev,
                          subcategoryId: [...(prev.subcategoryId || []), value],
                          staffId: [],
                        }))
                      }
                      onRemove={value =>
                        setFormData(prev => ({
                          ...prev,
                          subcategoryId: prev.subcategoryId?.filter(v => v !== value) || [],
                          staffId: [],
                        }))
                      }
                      placeholder="Select subcategory..."
                      valueField="_id"
                      labelField="name"
                      searchable
                    />
                  </div>
                  <div className={addjob.addjobselect}>
                    <label htmlFor="">Select *</label>
                    <MultiSelectCheckbox
                      options={partnerlist.data || []}
                      selectedValues={formData.staffId || []}
                      onSelect={value =>
                        setFormData(prev => ({
                          ...prev,
                          staffId: [...(prev.staffId || []), value],
                        }))
                      }
                      onRemove={value =>
                        setFormData(prev => ({
                          ...prev,
                          staffId: prev.staffId?.filter(v => v !== value) || [],
                        }))
                      }
                      placeholder="Select partners..."
                      valueField="_id"
                      labelField="firstName" // For staff, we'll show firstName + lastName
                      disabled={!formData.subcategoryId || formData.subcategoryId.length === 0}
                      searchable
                    />
                  </div>
                  <div className={addjob.showassinedstaff}>
                    <h3>Assigned Partner ({data?.staff?.length})</h3>
                    <ul>
                      {data?.staff?.length === 0 ? (
                        <p>N/A</p>
                      ) : (
                        data?.staff?.map((itme, rowIndex) => (
                          <li key={rowIndex}>
                            {itme.firstName} {itme.lastName}
                          </li>
                        ))
                      )}
                    </ul>
                  </div>
                  <div className={addjob.showassinedstaff}>
                    <h3>Accepted Partner ({data?.staffAccepted?.length})</h3>
                    <ul>
                      {data?.staffAccepted?.length === 0 ? (
                        <p>N/A</p>
                      ) : (
                        data?.staffAccepted?.map((itme, rowIndex) => (
                          <li key={rowIndex}>
                            {itme.firstName} {itme.lastName}
                          </li>
                        ))
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className={addjob.addjobbutton}>
              <div className={addjob.rightbuttons}>
                <button onClick={() => navigate(-1)}>Cancel</button>
              </div>
              <div className={addjob.rightbuttons}>
                <button onClick={handleAssign} style={{ background: '#F05423' }} disabled={loading}>
                  {loading ? 'Assigning...' : 'Assign'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default HOC(AssignJob);
